import { Link } from "react-router-dom";

import type { SiteSettings } from "@dteba/shared";

import { useLocale } from "@/features/i18n/locale-provider";
import { whatsappLink } from "@/lib/links";

export function SiteFooter({ settings }: { settings: SiteSettings | undefined }) {
  const { t } = useLocale();

  return (
    <footer className="bg-ink px-5 py-10 text-on-dark/72 sm:px-8 sm:py-14 lg:px-16 lg:py-18">
      <div className="mx-auto flex max-w-page flex-wrap justify-between gap-8">
        <div className="flex-1 basis-60">
          <p className="mb-3 font-serif text-2xl text-on-dark">{settings?.brandName ?? "D'Teba Villa"}</p>
          {/* One line per line, the way the CMS field and the contact page
              show it — joining them let the browser break the address
              wherever the column ran out. */}
          <p className="max-w-[34ch] text-[0.9375rem] leading-[1.7]">
            {(settings?.addressLines ?? []).map((line) => (
              <span key={line} className="block">
                {line}
              </span>
            ))}
          </p>
        </div>

        <div className="flex flex-wrap gap-12">
          <nav className="flex flex-col gap-2.5 text-[0.9375rem]" aria-label={t("footer.visit")}>
            <span className="font-semibold text-on-dark">{t("footer.visit")}</span>
            <Link to="/villa" className="text-on-dark/72 no-underline hover:text-on-dark">
              {t("nav.villa")}
            </Link>
            <Link to="/story" className="text-on-dark/72 no-underline hover:text-on-dark">
              {t("nav.story")}
            </Link>
            <Link to="/experiences" className="text-on-dark/72 no-underline hover:text-on-dark">
              {t("nav.experiences")}
            </Link>
          </nav>

          <nav className="flex flex-col gap-2.5 text-[0.9375rem]" aria-label={t("footer.contact")}>
            <span className="font-semibold text-on-dark">{t("footer.contact")}</span>
            {settings?.whatsappNumber && (
              <a
                href={whatsappLink(settings.whatsappNumber)}
                target="_blank"
                rel="noreferrer"
                className="text-on-dark/72 no-underline hover:text-on-dark"
              >
                WhatsApp
              </a>
            )}
            {settings?.bookingEmail && (
              <a
                href={`mailto:${settings.bookingEmail}`}
                className="text-on-dark/72 no-underline hover:text-on-dark"
              >
                {settings.bookingEmail}
              </a>
            )}
            <Link to="/legal/privacy" className="text-on-dark/72 no-underline hover:text-on-dark">
              {t("footer.legal")}
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
